import React from "react";
import { cn } from "@/lib/utils";

/**
 * Cinematic gradient placeholder poster / backdrop art.
 * Uses purely abstract gradients + geometric overlays — no real people/celebrities.
 */
export default function PosterArt({
  title,
  subtitle,
  gradient = "from-violet-600 via-blue-600 to-orange-500",
  aspect = "poster", // "poster" | "backdrop" | "square"
  size = "md",
  showTitle = true,
  className = "",
  overlayIntensity = 0.6,
}) {
  const ASPECT_MAP = { backdrop: "aspect-video", square: "aspect-square", poster: "aspect-[2/3]" };
  const TITLE_SIZE_MAP = { lg: "text-3xl md:text-4xl", sm: "text-sm", md: "text-lg md:text-xl" };
  const aspectClass = ASPECT_MAP[aspect] || ASPECT_MAP.poster;
  const titleSize = TITLE_SIZE_MAP[size] || TITLE_SIZE_MAP.md;

  return (
    <div className={cn("relative w-full overflow-hidden", aspectClass, className)}>
      <div className={cn("absolute inset-0 bg-gradient-to-br", gradient)} />
      {/* geometric overlays */}
      <div className="absolute inset-0 opacity-70 mix-blend-overlay"
        style={{ backgroundImage: "radial-gradient(circle at 30% 20%, rgba(255,255,255,0.35), transparent 45%), radial-gradient(circle at 80% 80%, rgba(0,0,0,0.55), transparent 55%)" }} />
      <div className="absolute inset-0 opacity-30"
        style={{ backgroundImage: "linear-gradient(115deg, transparent 40%, rgba(255,255,255,0.14) 50%, transparent 60%)" }} />
      {/* noise */}
      <div className="absolute inset-0 opacity-25 mix-blend-soft-light"
        style={{ backgroundImage: "radial-gradient(rgba(255,255,255,0.4) 1px, transparent 1px)", backgroundSize: "3px 3px" }} />
      {/* vignette */}
      <div className="absolute inset-0" style={{ background: `linear-gradient(180deg, rgba(0,0,0,0) 45%, rgba(0,0,0,${overlayIntensity}) 100%)` }} />

      {showTitle && title && (
        <div className="absolute inset-0 flex flex-col justify-end p-4 md:p-5">
          <div className="font-display font-extrabold text-white drop-shadow-[0_2px_10px_rgba(0,0,0,0.7)] leading-none tracking-tight">
            <div className={cn(titleSize, "uppercase")}>{title}</div>
          </div>
          {subtitle && (
            <div className="mt-2 text-[10px] md:text-xs uppercase tracking-[0.25em] text-white/70">{subtitle}</div>
          )}
        </div>
      )}
    </div>
  );
}
